import { Stack, TextField, useTheme } from '@mui/material';
import { Field } from 'formik';
import { useIntl } from 'react-intl';

export const ScoreModelEditorNameField = () => {
  const intl = useIntl();
  const usePalette = useTheme().palette
  const theme = useTheme();
  return (
    <Stack padding={1} marginY={1}>
      <Field
        sx={{backgroundColor: usePalette.secondary.main}}
        autoComplete={'off'}
        type={'text'}
        name={'name'}
        label={intl.formatMessage({
          id: 'ScoreModelName'
        })}
        as={TextField}
        inputProps={{
          style: {...theme.typography.body2}
        }}
      />
    </Stack>
  );
};
